export default "__VITE_ASSET__c0e66ed1__"